<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <!--<el-menu-item index="1" @click="toNewRouter('inspection-view')">-->
        <!--<i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>-->
        <!--<span slot="title">概览</span>-->
      <!--</el-menu-item>-->
      <el-menu-item index="2" @click="toNewRouter('inspection-device-type-manage')" v-if="permissionCodes.indexOf('024001000') !== -1">
        <i class="el-icon-damai-peizhi"></i>
        <span slot="title">巡检类目</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('inspection-device-manage')" v-if="permissionCodes.indexOf('024002000') !== -1">
        <i class="el-icon-damai-xunjiandian-copy" style="font-size: 20px;"></i>
        <span slot="title">巡检点管理</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('inspection-person-manage')" v-if="permissionCodes.indexOf('024003000') !== -1">
        <i class="el-icon-damai-yonghu" style="font-size: 20px;"></i>
        <span slot="title">巡检人员管理</span>
      </el-menu-item>
      <el-menu-item index="5" @click="toNewRouter('inspection-team-manage')" v-if="permissionCodes.indexOf('024004000') !== -1">
        <i class="el-icon-damai-banzu" ></i>
        <span slot="title">班组管理</span>
      </el-menu-item>
      <el-menu-item index="6" @click="toNewRouter('inspection-plan-manage')" v-if="permissionCodes.indexOf('024005000') !== -1">
        <i class="el-icon-damai-xunjianjihua"></i>
        <span slot="title">巡检计划</span>
      </el-menu-item>
      <el-menu-item index="7" @click="toNewRouter('inspection-task-manage')" v-if="permissionCodes.indexOf('024006000') !== -1">
        <i class="el-icon-damai-xunjianrenwu"></i>
        <span slot="title">巡检任务</span>
      </el-menu-item>
      <el-menu-item index="8" @click="toNewRouter('inspection-record')" v-if="permissionCodes.indexOf('024007000') !== -1">
        <i class="el-icon-damai-xunjian"></i>
        <span slot="title">巡检记录</span>
      </el-menu-item>
      <el-menu-item index="9" @click="toNewRouter('inspection-report')" v-if="permissionCodes.indexOf('024008000') !== -1">
        <i class="el-icon-damai-fl-baobiao"></i>
        <span slot="title">巡检报表</span>
      </el-menu-item>
      <el-menu-item index="10" @click="toNewRouter('inspection-log')" v-if="permissionCodes.indexOf('024009000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>

      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: "fire-over-view",
  2: [
    "inspection-device-type-manage",
    "inspection-device-type-add",
    "inspection-device-type-modify"
  ],
  3: [
    "inspection-device-manage",
    "inspection-device-add",
    "inspection-device-modify"
  ],
  4: [
    "inspection-person-manage",
    "inspection-person-add",
    "inspection-person-modify"
  ],
  5: [
    "inspection-team-manage",
    "inspection-team-add",
    "inspection-team-modify"
  ],
  6: [
    "inspection-plan-manage",
    "inspection-plan-add",
    "inspection-plan-modify"
  ],
  7: "inspection-task-manage",
  8: "inspection-record",
  9: "inspection-report",
  10: "inspection-log",
  11: ["asset-manage"]
});

export default {
  name: "inspection-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    }
  },
  data() {
    return {
      isCollapse: false,
      yqCode: "",
      permissionCodes: "",
      indexOfRouterNameEntities
    };
  },
  created() {
    this.yqCode = bus.global.yqCode;
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", data => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name
      });
    },
    previewStream() {
      window.open(`http://dm.damaiiot.com/login`, "_blank");
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/Inspection/InspectionNav.vue